import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { motion, LayoutGroup } from 'framer-motion';
import { Home, Image as ImageIcon, StickyNote } from 'lucide-react';
import { useCurrentMemorial } from '../context/CurrentMemorialContext';

const ACTIVE_BG = '#44231E';
const ACTIVE_FG = '#EFEBE0';
const INACTIVE_FG = '#8E7C69';

export default function Navbar() {
  const location = useLocation();
  const navigate = useNavigate();
  const { slug: currentSlug } = useCurrentMemorial();

  // Prefer stored slug; fall back to inferring from the URL.
  let slug = currentSlug;
  if (!slug && location.pathname.startsWith('/m/')) {
    const parts = location.pathname.split('/');
    if (parts.length >= 3) slug = parts[2];
  }

  const items = slug
    ? [
        { path: `/m/${slug}`,        Cmp: Home,       label: 'Home' },
        { path: `/m/${slug}/images`, Cmp: ImageIcon,  label: 'Photos' },
        { path: `/m/${slug}/notes`,  Cmp: StickyNote, label: 'Notes' },
      ]
    : [
        { path: '/', Cmp: Home, label: 'Home' },
      ];

  return (
    <>
      {/* ── Pill navigation, bottom-left ─────────────────────────── */}
      <motion.div
        initial={{ y: 24, opacity: 0 }}
        animate={{ y: 0, opacity: 1 }}
        transition={{ type: 'spring', stiffness: 260, damping: 24, delay: 0.02 }}
        className="fixed z-50"
        style={{ bottom: 24, left: 24 }}
      >
        <LayoutGroup id="bottomnav">
          <div
            className="flex items-center gap-1 rounded-full"
            style={{
              background: '#FFFFFF',
              padding: 8,
              boxShadow:
                '0 4px 10px rgba(64, 42, 20, 0.08), ' +
                '0 12px 28px rgba(64, 42, 20, 0.14)',
            }}
          >
            {items.map(({ path, Cmp, label }) => {
              const isActive = location.pathname === path;
              return (
                <motion.button
                  key={path}
                  onClick={() => navigate(path)}
                  whileTap={{ scale: 0.85 }}
                  transition={{ type: 'spring', stiffness: 400, damping: 20 }}
                  aria-label={label}
                  className="relative flex items-center justify-center focus:outline-none"
                  style={{
                    width: 56,
                    height: 56,
                    borderRadius: 999,
                    background: 'transparent',
                    border: 'none',
                    cursor: 'pointer',
                  }}
                >
                  {isActive && (
                    <motion.span
                      layoutId="nav-active-pill"
                      transition={{ type: 'spring', stiffness: 420, damping: 32 }}
                      className="absolute inset-0 rounded-full"
                      style={{ background: ACTIVE_BG }}
                    />
                  )}
                  <Cmp
                    size={28}
                    strokeWidth={isActive ? 2.2 : 1.9}
                    color={isActive ? ACTIVE_FG : INACTIVE_FG}
                    style={{ position: 'relative', zIndex: 1 }}
                  />
                </motion.button>
              );
            })}
          </div>
        </LayoutGroup>
      </motion.div>
    </>
  );
}
